export type DocumentRejectReason = 'ILLISIBLE' | 'CORROMPU' | 'NON_CONFORME' | 'AUTRE'

const documentRejectReasons: { key: DocumentRejectReason, text: string }[] = [
  { key: 'ILLISIBLE', text: 'Document illisible' },
  { key: 'CORROMPU', text: 'Document corrompu' },
  { key: 'NON_CONFORME', text: 'Document non conforme' },
  { key: 'AUTRE', text: 'Autre' },
]

const documentRejectReasonObject = {} as Record<string, string>
documentRejectReasons.forEach((e) => {
  documentRejectReasonObject[e.key] = e.text
})

export function getDocumentRejectReasonLabel(key?: string): string | undefined {
  return key && documentRejectReasonObject[key]
}

export default documentRejectReasons
